"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    {
        type: 'textfield',
        inputType: 'url',
        key: 'ariaction',
        input: true,
        weight: 5,
        label: 'Ari Action',
        tooltip: 'The API path that not included domain and API version.',
        placeholder: 'bo/bank/list',
        defaultValue: 'co/salarycriteria/list',
    },
    {
        type: 'textarea',
        key: 'operations',
        label: 'Custom operations list',
        tooltip: 'Custom operations list',
        rows: 5,
        editor: 'ace',
        input: true,
        weight: 6,
        placeholder: 'Data source in json format',
    },
];
